export const mediasSelector = (state) => state.mediaReducer.medias;
export const metaSelector = (state) => state.mediaReducer.meta;
export const resizeSelector = (state) => state.mediaReducer.resize;
export const videoSelector = (state) => state.mediaReducer.video;
export const monthSelector = (state) => state.mediaReducer.month;
export const mediaSelector = (state) => state.mediaReducer.media;
